import type { ScaleInput } from '@visx/scale';
import { coerceNumber } from '@visx/scale';
import type { AxisScale } from '@visx/xychart';

import { isValidNumber } from '../typeguards/isValidNumber';

/**
 * Returns the output value of a scale's baseline value, which is either zero
 * or the minimum scale value if its domain doesn't include zero.
 * Copied from visx internal utilities.
 */
export function getScaleBaseline<Scale extends AxisScale>(scale: Scale): number {
  const [a, b] = scale.range().map((rangeBoundary) => coerceNumber(rangeBoundary) ?? 0);
  const aIsDefined = a !== null && a !== undefined;
  const bIsDefined = b !== null && b !== undefined;
  const isDescending = aIsDefined && bIsDefined && b < a;
  const maybeScaleZero = scale(0 as ScaleInput<Scale>);
  const [minOutput, maxOutput] = isDescending ? [b, a] : [a, b];

  // if maybeScaleZero _is_ a number, but the scale is not clamped and it's outside the domain
  // fallback to the scale's minimum
  return isDescending
    ? isValidNumber(maybeScaleZero)
      ? Math.min(Math.max(minOutput, maybeScaleZero), maxOutput)
      : maxOutput
    : isValidNumber(maybeScaleZero)
      ? Math.max(maybeScaleZero, minOutput)
      : minOutput;
}
